<div class="center" *ngIf="loading" style="margin-top: 40px;">
  <mat-spinner [diameter]="25"></mat-spinner>
  <p style="margin-right: 16px;">در حال بارگذاری...</p>
</div>

<ng-container *ngIf="!loading">
  <div class="column">
    <h1 class="page-head">داشبورد</h1>
    <p>به پرتال کاربری برند ترین‌ها خوش‌آمدید. داشبورد شما نمایی کلی از مشخصات و فعالیت‌های شماست.</p>
    <mat-card class="flex row">
      <div class="row row-responsive">
        <div>
          <img width="100px" height="100px" [src]="userInfo.picture" alt="">
        </div>
        <div class="flex column">
          <div class="flex row-center">
            <span class="label">نام {{roleId|role}} :</span>
            <div class="value-1">
              {{userInfo.name + ' '+userInfo.family}}
            </div>
          </div>
          <div class="flex row-center">
            <span class="label">کد {{roleId|role}} :</span>
            <div class="value-1">
              {{userInfo.code}}
            </div>
          </div>
        </div>
        <div class="flex column">
          <div class="flex row-center">
            <span class="label">تاریخ عضویت :</span>
            <div class="value-1">
              {{userInfo.createDate|jalaliDate}}
            </div>
          </div>
          <div class="flex row-center">
            <div class="label">امتیاز :</div>
            <div>
              <ng-container *ngFor="let item of [1,2,3,4,5]">
                <mat-icon>
                  {{userInfo.score>=item ? 'star' :'star_border'}}
                </mat-icon>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
    <div *ngIf="monthlyPostReportChart" class="row row-responsive">
      <mat-card class="flex">
        <div class="row-center">
          <h4>تعداد آگهی‌های رایگان</h4>
          <div class="flex"></div>
          <div class="value">
            {{postCountInformation[1].count}}
          </div>
        </div>
      </mat-card>
      <mat-card class="flex">
        <div class="row-center">
          <h4>تعداد آگهی‌های ویژه</h4>
          <div class="flex"></div>
          <div class="value">
            {{postCountInformation[0].count}}
          </div>
        </div>
      </mat-card>
      <mat-card class="flex row-center">
        <div class="row-center">
          <h4>کیف پول</h4>
          <div class="flex"></div>
          <div class="value">
            {{walletAmount[0].wallet|number}}
          </div>
        </div>
      </mat-card>
    </div>
    <mat-card *ngIf="monthlyPostReportChart">
      <ex-charts title="تعداد آگهی‌ها در ماه" [chartOption]="monthlyPostReportChart" class="flex"></ex-charts>
    </mat-card>
    <bt-subset *ngIf="!monthlyPostReportChart"></bt-subset>
  </div>
</ng-container>
